import React, { useEffect, useState } from 'react'
import { Button, Form, Modal } from 'react-bootstrap'
import toast from 'react-hot-toast'
import {Table, Tbody, Td, Thead, Tr } from 'react-super-responsive-table'
import ApiEndpoints, {BASE_URL} from './commonComponents/ApiEndpoints'
import { Settings } from 'react-feather'
import axios from 'axios'
import { PencilSquare } from 'react-bootstrap-icons'
import EditConfigModal from './EditConfigModal'
import { useAuth } from './AuthContext'

const Setting = () => {
  const {token} = useAuth()
  const [marginLeft, setMarginLeft] = useState(
    window.innerWidth > 768 ? '300px' : '0px',
  )

  const [showModal, setShowModal] = useState(false)
  const [showEditModal, setShowEditModal] = useState(false)
  const [selectedConfig, setSelectedConfig] = useState(false)
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState([])
  const [isAcknowledged, setIsAcknowledged] = useState(false)

  const [newConfig, setNewConfig] = useState({ key: '', value: '' })

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          BASE_URL+'/get/all/setting',
          {headers: { Authorization: `Bearer ${token}` }  }
        )
        console.log('RESPONSE OF Config:', response)
        setData(response.data.data)
      } catch (error) {
        console.error(error.response?.data?.message)
      }
    }
    fetchData()
  }, [loading])
  const handleInputChange = (e) => {
    const { name, value } = e.target
    console.log(
      `Input Changed - Name: ${name}, Value: ${value} (Type: ${typeof value})`,
    )
    setNewConfig((prev) => ({ ...prev, [name]: value }))
  }
  const handleSave = async (e) => {
    e.preventDefault()
    try {
      setLoading(true)
      console.log('Sending data: ', newConfig)
      const payload = {
        ...newConfig,
        value: parseInt(newConfig.value, 10),
      }
      const response = await ApiEndpoints.addConfig(payload)
      toast.success(response.data.message)

      // setNewConfig((prev) => [...prev, response.data.data])
      setNewConfig(response.data.data)
      // Reset the form after submission
      setNewConfig({
        key: '',
        value: '',
      })

      setShowModal(false)
    } catch (error) {
      toast.error(
        error.response?.data?.errors?.key?.[0] || 'Something wents wrong.',
      )
      setShowModal(false)
    } finally {
      setLoading(false)
    }
  }
  return (
    <div style={{ marginLeft }}>
      <div
        className="container-fluid p-0"
        style={{
          marginTop: window.innerWidth < 768 ? '55px' : '-12px',
        }}
      >
        <div className="bg-secondary p-3 rounded d-flex flex-wrap justify-content-between align-items-center text-white">
          <h2 className="m-0">Config</h2>
          <Button
            variant="light"
            className="fw-bold"
            onClick={() => setShowModal(true)}
          >
            <Settings size={18} className="me-2" />
            Add New Config
          </Button>
        </div>
      </div>

        <Table className="table table-striped table-bordered table-hover rounded overflow-hidden shadow-sm mb-0 mt-4" >
             <Thead className="bg-dark text-white">
              <Tr>
            <th>Key</th>
            <th>Value</th>
            <th>Action</th>
          </Tr>
        </Thead>
        <Tbody>
          {data.length > 0 ? (
            data.map((item, index) => (
              <Tr key={index}>
                <Td>{item.key || 'N/A'}</Td>
                <Td>{item.value || 'N/A'}</Td>
                <Td>
                  <Button
                    variant="warning"
                    onClick={() => {
                      setSelectedConfig(item)
                      setShowEditModal(true)
                    }}
                  >
                    <PencilSquare />
                  </Button>
                </Td>
              </Tr>
            ))
          ) : (
            <Tr>
              <Td colSpan={3}>No Records Found</Td>
            </Tr>
          )}
        </Tbody>
      </Table>
      <Modal
        size="lg"
        show={showModal}
        onHide={() => setShowModal(false)}
        centered
      >
        <Modal.Header closeButton className="text-white bg-secondary">
          <Modal.Title>Add New Config</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSave}>
            {/* Class Name Field */}
            <Form.Group className="mb-3">
              <Form.Label>Key</Form.Label>
              <Form.Control
                type="text"
                name="key"
                value={newConfig.key}
                onChange={handleInputChange}
                placeholder="Enter Key"
                className="p-2 border rounded"
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Value</Form.Label>
              <Form.Control
                type="text"
                name="value"
                value={newConfig.value}
                onChange={handleInputChange}
                placeholder="Enter Value"
                className="p-2 border rounded"
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Check
                className="text-danger"
                type="checkbox"
                id="acknowledgeCheckbox"
                label="I acknowledge and agree that this process is irreversible and cannot be undone."
                checked={isAcknowledged}
                onChange={(e) => setIsAcknowledged(e.target.checked)}
              />
            </Form.Group>

            <Modal.Footer>
              <Button variant="danger" onClick={() => setShowModal(false)}>
                Cancel
              </Button>
              <Button
                variant="success"
                type="submit"
                disabled={!isAcknowledged}
              >
                Save Config
              </Button>
            </Modal.Footer>
          </Form>
        </Modal.Body>
      </Modal>
      <EditConfigModal
        show={showEditModal}
        handleClose={() => setShowEditModal(false)}
        config={selectedConfig}
      />
    </div>
  )
}

export default Setting
